module.exports = __webpack_public_path__ + "img/m_img_charge@2x.d662851a.png";